module.exports = __webpack_public_path__ + "static/media/wasabi.9338ba78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/wasabi.jpg
// module id = 139
// module chunks = 0